import { render, staticRenderFns } from "./Wp_tb_sku_detail_page.vue?vue&type=template&id=229c09a8&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./Wp_tb_sku_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_sku_detail_page.vue?vue&type=script&lang=js&"
import style0 from "./Wp_tb_sku_detail_page.vue?vue&type=style&index=0&id=229c09a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c09a8",
  null
  
)

export default component.exports